import React from 'react';
import styled from 'styled-components';

const NotFound = () => {
    return <Container></Container>;
};

export default NotFound;

const Container = styled.div`
    width: 100%;
    height: 100vh;
    background-image: url('https://d2ug3aglf1tff7.cloudfront.net/image/404.png');
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    background-color: black;
`;
